import ApiService from "@/common/api/api.service";

const Detalhes = {

    listar: function(id) {
        return ApiService.get(`ProjetoGestao/empresas-associadas?ProjetoGestaoId=${id}`);
    },
    
    salvar : function(form){
        return ApiService.post("ProjetoGestao/associar-empresas", form);
    },
    
    listarModal : function(id){
        return ApiService.get(`ProjetoGestao/empresas-associaveis?ProjetoGestaoId=${id}`);
    },
    
    removerEmpresa : function(id, empresaid){
        return ApiService.delete(`ProjetoGestao/empresa-cooperada?ProjetoGestaoId=${id}&EmpresaId=${empresaid}`);
    }
        

};

export default Detalhes;